import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=1d299fd2&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=1d299fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d299fd2",
  null
  
)

export default component.exports